var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import cs from '../_util/classNames';
import { ConfigContext } from '../ConfigProvider';
function Meta(props, ref) {
    var getPrefixCls = useContext(ConfigContext).getPrefixCls;
    var className = props.className, avatar = props.avatar, title = props.title, description = props.description, others = __rest(props, ["className", "avatar", "title", "description"]);
    var prefixCls = getPrefixCls('list');
    var baseClassName = prefixCls + "-item-meta";
    var hasAvatar = !!avatar;
    var hasContent = !!(title || description);
    return (React.createElement("div", __assign({ ref: ref }, others, { className: cs(baseClassName, className) }),
        hasAvatar && React.createElement("div", { className: baseClassName + "-avatar" }, avatar),
        hasContent && (React.createElement("div", { className: baseClassName + "-content" },
            title && React.createElement("div", { className: baseClassName + "-title" }, title),
            description && React.createElement("div", { className: baseClassName + "-description" }, description)))));
}
var MetaComponent = React.forwardRef(Meta);
MetaComponent.displayName = 'ListItemMeta';
export default MetaComponent;
